import React from "react";
import finalPoster from "../final_poster.png";

export default function Poster() {
  return (
    <div>
      <img src={finalPoster} id="poster-image" style={{ width: "100%" }} />
      <a
        target="_blank"
        id="poster-image-link"
        title="click to expand"
        alt="franks poster image 2020"
        href={finalPoster}
      >
        <p
          style={{
            fontSize: "0.6rem",
            textAlign: "center",
            margin: "-0.2em 0 1.5rem",
          }}
        >
          open poster image in new tab
        </p>
      </a>
    </div>
  );
}
